import React, { FC } from 'react';

import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import FundProfileShowPageContainer from '@buyside/components/container/FundProfileShow/FundProfileShowPageContainer';

const FundProfileShowPageRoot: FC<{ employerProfileId: string }> = ({ employerProfileId }) => {
  if (!employerProfileId) return;

  return (
    <ErrorBoundary pageName="the fund profile">
      <FundProfileShowPageContainer employerProfileId={employerProfileId} />
    </ErrorBoundary>
  );
};

export default FundProfileShowPageRoot;
